import PropTypes from 'prop-types';
import { CurrencyInput } from 'components/FormControl';
import { formatFileName } from 'utils/func';
import { REGISTER_RESULT_FILE_TYPE } from 'constant';
import DownloadOrViewPdf from 'components/DownloadOrViewPdf';
import UploadAppendixes from './UploadAppendixes';

export default function ExpenditureAndAppendix({
  control,
  errors,
  disabled,
  registerResultId,
  minuteFile,
  appendixeArray,
  handleDownloadFile,
  isLiquidation,
}) {
  return (
    <>
      <h4>Các khoản kinh phí</h4>
      <div className="flex flex-column lg:flex-row lg:gap-4 gap-2">
        <CurrencyInput
          label="Tổng số tiền quyết toán (VNĐ)"
          name="settlementAmount"
          control={control}
          errors={errors}
          readOnly={disabled}
        />
        <CurrencyInput
          label={isLiquidation ? 'Tổng số tiền thu hồi (VNĐ)' : 'Tổng số tiền tiết kiệm (VNĐ)'}
          name={isLiquidation ? 'recoveryAmount' : 'savingsAmount'}
          control={control}
          errors={errors}
          readOnly={disabled}
        />
      </div>

      <h4 className="mt-0 mb-0">Biên bản thanh lý {isLiquidation ? 'không' : ''} hợp đồng</h4>

      {minuteFile && (
        <DownloadOrViewPdf
          opts={{
            filename: minuteFile,
            type: REGISTER_RESULT_FILE_TYPE.MINUTE,
          }}
          fileName={formatFileName(minuteFile)}
          handleDownloadOrView={handleDownloadFile}
          showIcon
        />
      )}

      <UploadAppendixes
        disabled={disabled}
        control={control}
        errors={errors}
        appendixeArray={appendixeArray}
        handleDownloadFile={handleDownloadFile}
        registerResultId={registerResultId}
      />
    </>
  );
}

ExpenditureAndAppendix.propTypes = {
  control: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
  disabled: PropTypes.bool,
  registerResultId: PropTypes.string,
  minuteFile: PropTypes.string,
  appendixeArray: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      filename: PropTypes.string,
    })
  ),
  handleDownloadFile: PropTypes.func,
  isLiquidation: PropTypes.bool,
};

ExpenditureAndAppendix.defaultProps = {
  disabled: false,
  registerResultId: null,
  minuteFile: null,
  appendixeArray: [],
  handleDownloadFile: () => null,
  isLiquidation: false,
};
